import React from 'react'

import './styles/preview-option.scss';

interface Props {
    label: string,
    value: string | number
}

function PreviewOption({label, value}: Props) {
    return (
        <div className="preview-option">
            <label className={'preview-option__label'}>{ label }:</label>
            <span className={'preview-option__value'}>{ value }</span>
        </div>
    )
}

export default PreviewOption